import type { IAddCancellationCmd } from "@/data/commands/order/AddCancellationCmd";

import { createEmptyDiv, createVueComponent } from "@/shared/utils/vue";
import CancellationReasonModal from "@/components/order/CancellationReasonModal.vue";


export interface AddCancellationOptions {
    locationId: string;
    orderId: string;
    data: IAddCancellationCmd;
    cancellableAmount: number;
    onSaveStart: () => void;
    onSaveError: (errorCode: string, errorMessage: string) => void;
    onSaveEnd: () => void;
}

export function showSelectCancellationReasonModal(options: AddCancellationOptions) {
    const props = {
        locationId: options.locationId,
        orderId: options.orderId,
        cancellableAmount: options.cancellableAmount,
        data: options.data,
        onSaveStart: options.onSaveStart,
        onSaveError: options.onSaveError,
        onSaveEnd: options.onSaveEnd,
    };

    const result = createVueComponent(CancellationReasonModal, props, createEmptyDiv());
    const cancellationReasonModal = result.mountedComponent;
    cancellationReasonModal.show();
}
